import { useEffect, useState } from 'react'

import { ApiService } from '@/service'
import useStore from '@/store/useStore'
import { ChannelType, EventType } from '@/types/servicesTypes/configTypes'

export const useEventChannel = (event?: Nullable<EventType>) => {
  const allChannels = useStore((state) => state.common.allChannels)
  const setAllChannels = useStore((state) => state.common.setAllChannels)
  const [eventChannel, setEventChannel] = useState<Nullable<ChannelType>>()

  useEffect(() => {
    // Some channel ids have a space and dirt at the end, so we need to truncate it
    const channelId = event?.channelId?.split(' ')[0]

    if (!channelId) {
      setEventChannel(null)
    }
    if (channelId !== eventChannel?.id) {
      void getEventChannel(allChannels, channelId)
    }
  }, [event, allChannels, eventChannel])

  const getEventChannel = async (
    allChannels: Nullable<ChannelType[]>,
    channelId?: string,
  ) => {
    if (!channelId) {
      return
    }

    let channel = allChannels?.find((channel) => channel.id === channelId)

    if (!channel) {
      try {
        channel = await ApiService.getChannelById(channelId)
        const allChannels = useStore.getState().common.allChannels
        if (!allChannels?.some((channel) => channel.id === channelId)) {
          setAllChannels([...(allChannels || []), channel])
        }
      } catch (e) {
        // console.warn('[EventDetailPage] hook: channel request error', channelId)
      }
    }

    setEventChannel(channel || null)
  }

  return eventChannel
}
